/* eslint-disable max-len */
import { formatDescription } from '../../helpers/product-helpers';

export const transformBrandName = (brandName) => {
  // eslint-disable-next-line
  if (brandName === undefined || brandName?.toLowerCase() === 'unbranded') {
    return '';
  }
  return brandName;
};

export const removeDoubleSpaces = (sentence) => {
  return sentence.replace(/\s{2,}/g, ' ');
};

export const generatePprTitle = ({
  brandName,
  identifiers = {},
  props = {},
  seoPageNumber,
  productDescription
}) => {
  let pageTitle;
  // eslint-max-line-length
  const defaultTitle = `${brandName} ${identifiers?.productLabel || ''} ${identifiers?.modelNumber || ''} ${props?.pageNumber ? '| Pg' + props.pageNumber : ''}`.trim();
  if (props?.ppq) {
    pageTitle = removeDoubleSpaces(
      `Have a question about ${productDescription}? - Pg ${seoPageNumber} - The Home Depot`);
  } else if (props?.pageNumber) {
    pageTitle = removeDoubleSpaces(
      `Reviews for ${productDescription} | Pg ${seoPageNumber} - The Home Depot`
    );
  }

  return pageTitle?.trim() || defaultTitle;
};

export const generatePprDescription = ({
  seoDescription,
  details = {},
  identifiers = {},
  props = {},
  seoPageNumber,
  productDescription
}) => {
  let pageDescription;
  const defaultDescription = formatDescription(seoDescription || details?.description);
  if (props?.ppq) {
    pageDescription = removeDoubleSpaces(
      `See what other customers have asked about ${productDescription} ${identifiers?.modelNumber} on Page ${seoPageNumber}.`);
  } else if (props?.pageNumber) {
    pageDescription = removeDoubleSpaces(
      `Read page ${seoPageNumber} of our customer reviews for more information on the ${productDescription}.`
    );
  }

  return pageDescription || defaultDescription;
};

export const generatePprEncodedPath = ({ identifiers, props }) => {
  const { canonicalUrl: canonicalPath = '' } = identifiers || {};
  let identifierCanonicalUrl = canonicalPath;
  if (props?.ppq) {
    identifierCanonicalUrl = canonicalPath?.replace('/p/', '/p/questions/');
  } else {
    identifierCanonicalUrl = canonicalPath?.replace('/p/', '/p/reviews/');
  }

  const resultedPath = props?.pageNumber ? identifierCanonicalUrl?.concat(`/${props.pageNumber}`) : identifierCanonicalUrl;
  return encodeURI(resultedPath);
};

export const getAggregateReviews = (data) => {
  const aggregateReviews = {};

  if (data?.reviews?.Includes?.Products?.store?.FilteredReviewStatistics?.AverageOverallRating
    && data?.reviews?.TotalResults) {
    aggregateReviews.averageRating = data.reviews.Includes.Products.store.FilteredReviewStatistics.AverageOverallRating;
    aggregateReviews.totalReviews = data.reviews.TotalResults;
  }
  return aggregateReviews;
};
